import Message from '../containers/Message';

async function retrieveMessage(nextPath: string){
  // const path = '/api/asebi/messages/{id}'.replace('{id}', id.toString());
  const path = nextPath ?? '/api/asebi/messages';
  const resp = await fetch(path);
  const json = await resp.json();

  // const data = new Message();
  // data.load(json);
  // return data;
  
  // Message型ではなく、そのまま返す
  return json;
}

export default retrieveMessage;
